import { type ColumnType } from 'antd/es/table/interface';
import type { InvoiceReportDetailJournalEntriesResponseItem } from 'ap-openapi';

export const filterColumns = (
  columns: ColumnType<
    InvoiceReportDetailJournalEntriesResponseItem & { id: string }
  >[],
  listColumns: string[]
) => {
  return columns.filter(
    (column) => column?.key && listColumns.includes(String(column.key))
  );
};
